import { Link } from 'react-router-dom';
import { useLang } from '../i18n/context';
import { SITE, waLink, mailLink } from '../lib/site';
import Logo from './Logo';
import { WaIcon } from './CTAs';

export default function Footer() {
    const { lang, t } = useLang();
    const P = `/dental/${lang}`;
    return (
        <footer className="bg-ink text-peri-200">
            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-12 lg:py-20">
                <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
                    <div className="lg:col-span-2">
                        <Logo light />
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-peri-300">{t.footer.about}</p>
                        <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 font-serif text-lg italic text-white">
                            {SITE.promise.map((p) => <span key={p}>{p}</span>)}
                        </div>
                        <p className="mt-5 text-xs uppercase tracking-[0.22em] text-peri-500">{SITE.location}</p>
                    </div>
                    <div>
                        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-peri-500">{t.footer.quickLinks}</p>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            <li><Link className="hover:text-white" to={P}>{t.nav.home}</Link></li>
                            <li><Link className="hover:text-white" to={`${P}/teen-smile`}>{t.nav.teen}</Link></li>
                            <li><Link className="hover:text-white" to={`${P}/patient-stories`}>{t.nav.stories}</Link></li>
                            <li><Link className="hover:text-white" to={`${P}/kolum`}>{t.footer.kolum}</Link></li>
                            <li><Link className="hover:text-white" to={`${P}/about`}>About</Link></li>
                            <li><a className="hover:text-white" href="/dental/about-klinik-pergigian-irma-ariandi" data-testid="footer-clinic-facts">Clinic Facts</a></li>
                            <li><Link className="hover:text-white" to={`${P}/contact`}>{t.footer.contact}</Link></li>
                            <li className="pt-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-peri-500">iINSPIRE Ecosystem</li>
                            <li><Link className="hover:text-white" to="/" data-testid="footer-eco-home">iINSPIRE Home</Link></li>
                            <li><Link className="hover:text-white" to="/consulting" data-testid="footer-eco-consulting">Consulting</Link></li>
                            <li><Link className="hover:text-white" to="/creative" data-testid="footer-eco-creative">Creative</Link></li>
                            <li><Link className="hover:text-white" to="/coffee-with-dr-irma" data-testid="footer-eco-coffee">Coffee With Dr. Irma</Link></li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-peri-500">{t.footer.treatments}</p>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            {t.nav.treatmentsMenu.map((it) => (
                                <li key={it.slug}><Link className="hover:text-white" to={`${P}/treatments/${it.slug}`}>{it.title}</Link></li>
                            ))}
                        </ul>
                        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.22em] text-peri-500">{t.footer.international}</p>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            <li><Link className="hover:text-white" to={`${P}/international/singapore`}>Singapore</Link></li>
                            <li><Link className="hover:text-white" to={`${P}/international/indonesia-batam`}>Indonesia / Batam</Link></li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-peri-500">{t.footer.contact}</p>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li>
                                <a href={waLink('')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-white" data-testid="footer-whatsapp">
                                    <WaIcon className="h-4 w-4 text-wa" /> {SITE.whatsappDisplay}
                                </a>
                            </li>
                            <li><a href={mailLink('')} className="break-all hover:text-white">{SITE.email}</a></li>
                            <li className="text-peri-300">{t.footer.address}</li>
                            <li className="text-xs text-peri-500">{t.footer.addressSlot}</li>
                        </ul>
                        <ul className="mt-6 space-y-2 text-sm">
                            <li><Link className="underline underline-offset-4 hover:text-white" to={`${P}/privacy`}>{t.footer.privacy}</Link></li>
                            <li><Link className="underline underline-offset-4 hover:text-white" to={`${P}/disclaimer`}>{t.footer.disclaimer}</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 border-t border-white/10 pt-6">
                    <p className="text-xs leading-relaxed text-peri-500">{t.footer.disclaimerLine}</p>
                    <p className="mt-2 text-xs text-peri-500">© 2026 {t.footer.rights}</p>
                </div>
            </div>
        </footer>
    );
}
